import * as dates from 'commons/models/dates';
import GenericGrid from 'pages/tables/GenericGrid';
import PropTypes from 'prop-types';
import React, { Fragment, useState } from 'react';
import CreateNoteModal from '../modals/CreateNoteModal';
import { useAddCampagneNoteMutation, useRemoveCampagneNoteMutation, useUpdateCampagneNoteMutation } from '../../../../redux/api/cache';

export default function Note(props) {
  const [data, setData] = useState(props.data.data);
  const [createModal, setCreateModal] = useState(false);
  const [selectedRow, setSelectedRow] = useState(undefined);
  const [addCampagneNote] = useAddCampagneNoteMutation();
  const [updateCampagneNote] = useUpdateCampagneNoteMutation();
  const [removeCampagneNote] = useRemoveCampagneNoteMutation();

  const fileClicked = (rowData) => {
    setSelectedRow(rowData);
    setCreateModal(true);
  };

  const remove = async () => {
    let result = await removeCampagneNote({
      seq: props.project.camp_seq, media: props.mediaKey, titre: selectedRow.campmn_titre, campr_date: dates.dateQueryFormatReverse(
        selectedRow.campr_date
      ), diff_cd: selectedRow.diff_cd, mf_format: selectedRow.mf_format
    }).unwrap();
    if (result.success) {
      let newData = JSON.parse(JSON.stringify(data));
      newData.splice(
        newData.findIndex(
          (item) => item.campmn_titre === selectedRow.campmn_titre
        ),
        1
      );
      setData(newData);
    }
  };

  const create = async (values) => {
    if (selectedRow === undefined) {
      let result = await addCampagneNote(values).unwrap();
      if (result.success) {
        let newData = JSON.parse(JSON.stringify(data));
        newData.push(result.data[0]);
        setData(newData);
      }
    } else {
      let result = await updateCampagneNote(values).unwrap();
      if (result.success) {
        let newData = JSON.parse(JSON.stringify(data));
        newData.splice(
          newData.findIndex((item) => item.titre === selectedRow.titre),
          1
        );
        newData.push(result.data[0]);
        setData(newData);
      }
    }
  };

  return (
    <Fragment>
      {createModal && (
        <CreateNoteModal
          rowData={props.project}
          selectedRow={selectedRow}
          media={props.mediaKey}
          create={create}
          remove={remove}
          toggleDialog={() => {
            setCreateModal(false);
            setSelectedRow(undefined);
          }}
        />
      )}
      <GenericGrid
        autoSize={true}
        showCreateBtn={props.showAddButton}
        onCreateClick={() => {
          setSelectedRow(undefined);
          setCreateModal(true);
        }}
        rowClicked={fileClicked}
        definition={props.data.meta.definition}
        txtBtn="Ajouter une note"
        data={data}
      ></GenericGrid>
    </Fragment>
  );
}

Note.propTypes = {
  data: PropTypes.shape({
    data: PropTypes.array,
    meta: PropTypes.shape({
      definition: PropTypes.array,
    }),
  }),
  mediaKey: PropTypes.string,
  path: PropTypes.string,
  project: PropTypes.shape({
    camp_seq: PropTypes.any,
  }),
  showAddButton: PropTypes.bool
};
